export default "__VITE_ASSET__e056a054__"